import QuoteInsuranceButtonWrapper from "./QuoteInsuranceButtonWrapper";

export default QuoteInsuranceButtonWrapper;
